<template>
  <v-app class="bckgrnd">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <div style="text-align:center">
        <b-form-radio-group
             v-model="selected"
             :options="options"
            ></b-form-radio-group>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation v-if="selected == 'details'">
        <v-layout row wrap>
            <v-flex xs12 v-if="form.profileSrc == null || form.idSrc == null">
                <v-btn block large dark class="flashing_effect" depressed @click="viewDoc()">Upload Document</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md9 v-if="form.profileSrc != null && form.idSrc != null"></v-flex>
            <v-flex xs12 sm12 md3 v-if="form.profileSrc != null && form.idSrc != null">
                <v-btn block large dark color="primary" depressed @click="viewDoc()">View & Edit Document</v-btn>
            </v-flex>
            <v-flex xs12 style="padding-bottom:15px">
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          </v-flex>
          <v-flex xs12 sm12 md8 style="padding-right:5px">
            <v-text-field disabled v-model="form.name" label="Student's Name"></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4>
              <v-dialog :disabled="edit === false" ref="dialog" v-model="dateModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="form.admissionDate"
                                label="Admission Date"
                                append-icon="event"
                                readonly
                                 :disabled="edit === false"
                              ></v-text-field>
                              <v-date-picker v-model="form.admissionDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>

          <v-flex xs12 sm12 md4 style="padding-right:5px">
              <v-text-field disabled v-model="form.email" label="Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 style="padding-right:5px">
              <v-text-field disabled v-model="form.mobileNumber" label="Mobile Number"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
              <v-text-field disabled v-model="form.levelName" label="Level"></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md3 style="padding-right:5px">
              <v-text-field disabled v-model="form.guardianName" label="Guardian Name"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px">
              <v-text-field disabled v-model="form.guardianNo" label="Guardian Number"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px">
              <v-text-field disabled v-model="form.guardianEmail" label="Guardian Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3>
              <v-text-field disabled v-model="form.relation" label="Relation"></v-text-field>
          </v-flex>

          <v-flex xs12>
              <v-toolbar flat color="transparent">
                  <h5 class="grey--text">Training Type Selection(s)</h5>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog1" max-width="800px" persistent>
                  <v-btn small color="primary" flat outline slot="activator" :disabled="edit === false">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                      <v-card-text>
                          <v-container grid-list-md>
                              <v-form ref="form1" v-model="valid" lazy-validation>
                              <v-layout wrap row>
                                  <v-flex xs12>
                                      <v-autocomplete
                              dense
                              v-model="selectedType"
                              :items="type"
                              label="Select Training Type"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                                      <v-text-field type="Number" v-model="form1.fee" label="Fee *" :rules="emptyRule" required></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                                      <v-text-field type="Number" v-model="form1.classNo" label="No. of Classes *" :rules="emptyRule" required></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm12 md4>
                                      <v-autocomplete
                              dense
                              v-model="selectedMode"
                              :items="mode"
                              label="Select Training Mode"
                              item-text="mode"
                              item-value="mode"
                              :rules="emptyRule"
                              required
                              ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs12>
                                      <v-autocomplete
                              dense
                              v-model="selectedTeacher"
                              :items="teacher"
                              label="Select Teacher"
                              item-text="fullName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>
                              </v-layout>
                              </v-form>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                  </v-card>
              </v-dialog>
              </v-toolbar>

              <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.fee }}</td>
                <td class="text-xs-left">{{ props.item.classNo }}</td>
                <td class="text-xs-left">{{ props.item.mode }}</td>
                <td class="text-xs-left">{{ props.item.fullName }}</td>
                <td class="justify-center">
                  <v-icon :disabled="edit === false" color="primary" class="ml-1" small @click="editItem(props.item)">create</v-icon>
                  <v-icon :disabled="edit === false" color="error" class="ml-1" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <v-btn :disabled="edit === false" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
            <v-btn depressed color="orange" dark @click="back()">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>


      <div v-if="selected == 'attendance'">
        <div style="text-align:right">
          <v-btn depressed color="primary" small @click="doAttendance()">New Attendance</v-btn>
        </div>
        <div style="text-align:center;padding:15px">
          <h5 class="grey--text">{{form.name}}'s Attendance Sheet</h5>
        </div>
        <v-layout wrap row>
          <v-flex xs12 sm12 md1 v-for="(item,index) in list" :key="item.id" style="margin-right:5px">
            <v-card v-if="index%2 == 0" flat class="txt_dec" to="/attendance" style="cursor: pointer;background-color:#1976D2;margin-top:0px;text-align:center;border-radius:5px">
                     
                        <v-tooltip top color="#f99420">
                   <template v-slot:activator="{ on }">
                     <v-sheet color="transparent" style="padding-top:15px" v-on="on">
                            <v-avatar :size="50" style="background-image: linear-gradient(-180deg, #9e9e9e, #ffff);background-size;border: 1px solid;border-color:black">
                                <h1 style="font-size:20px;font-weight:bold">{{item.classNo}}</h1>
                        </v-avatar>
                        </v-sheet>
                   </template>
                   <span>{{item.remarks}}</span>
               </v-tooltip>
                            
                            <h6 style="font-size:12px;color:white;padding-top:5px;margin-bottom:0px">{{item.name}}</h6>
                            <h6 style="font-size:12px;color:white;padding-top:0px;padding-bottom:5px">{{item.date}}</h6>
                        
                </v-card>
                <v-card v-if="index%2 != 0" flat class="txt_dec" to="/attendance" style="cursor: pointer;background-color:#f99420;margin-top:0px;text-align:center;border-radius:5px">
                     
                        <v-tooltip top color="#1976D2">
                   <template v-slot:activator="{ on }">
                     <v-sheet color="transparent" style="padding-top:15px" v-on="on">
                            <v-avatar :size="50" style="background-image: linear-gradient(-180deg, #9e9e9e, #ffff);background-size;border: 1px solid;border-color:black">
                                <h1 style="font-size:20px;font-weight:bold">{{item.classNo}}</h1>
                        </v-avatar>
                        </v-sheet>
                   </template>
                   <span>{{item.remarks}}</span>
               </v-tooltip>
                            
                            <h6 style="font-size:12px;color:white;padding-top:5px;margin-bottom:0px">{{item.name}}</h6>
                            <h6 style="font-size:12px;color:white;padding-top:0px;padding-bottom:5px">{{item.date}}</h6>
                        
                </v-card>
          </v-flex>
        </v-layout>
      </div>



      <div v-if="selected == 'mockTest'">
        <div style="text-align:right">
          <v-btn depressed color="primary" small @click="doMockTest()">New Mock Test</v-btn>
        </div>
        <div style="text-align:center;padding:15px">
          <h5 class="grey--text">{{form.name}}'s Mock Test</h5>
        </div>
        <v-layout wrap row>
          <v-flex xs12>
            <v-tabs
      v-model="tab"
      style="background-color:#3486D7"
      grow
      dark
    >
      <v-tab
        v-for="item in mockData"
        :key="item.id"
        style="background-color:#3486D7"
        dark
      >
        <v-badge
        color="red"
        right
        v-if="item.details.length > 0"
      >
        <span slot="badge">{{ item.details.length }}</span>
        {{ item.name }}
      </v-badge>
      <v-badge v-if="item.details.length == 0">{{ item.name }}</v-badge>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in mockData"
        :key="item.id"
      >
      
        <v-timeline>
          <v-timeline-item v-for="(mock, i) in item.details" :key="i" small>
            <span
              slot="opposite"
              :class="`font-weight-dark`"
              style="color:black"
            >Test Date: {{mock.date}}</span>
            <div style="background-color:#F99420;padding:10px;border-radius:5px">
              <h6>Class No : {{mock.classNo}}</h6>
              <div>Results :&nbsp;{{mock.result}}</div>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-tab-item>
    </v-tabs-items>
          </v-flex>
        </v-layout>
      </div>


      <div v-if="selected == 'registration'">
        <div style="text-align:right">
          <v-btn depressed color="primary" small @click="doRegistration()">New Test Registration</v-btn>
        </div>
        <div style="text-align:center;padding:15px">
          <h5 class="grey--text">{{form.name}}'s Test Registration</h5>
        </div>
        <v-layout wrap row>
          <v-flex xs12>
            <v-data-table
              :headers="header1"
              :items="registrations"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.registrationDate }}</td>
                <td class="text-xs-left">{{ props.item.conformation }}</td>
                <td class="text-xs-left">{{ props.item.testDate }}</td>
                <td class="text-xs-left">{{ props.item.resultDate }}</td>
                <td class="text-xs-left">{{ props.item.result }}</td>
                <td class="justify-center">
                  <v-icon color="primary" class="ml-1" small @click="editItem1(props.item)">create</v-icon>
                  <v-icon color="error" class="ml-1" small @click="deleteItem1(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </div>
    </v-card>


    <v-dialog v-model="dialogA" width="700px">
      
      <v-card>
        <v-container>
         <v-form ref="formA" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-autocomplete
                              dense
                              v-model="selectedType1"
                              :items="type1"
                              label="Select Training Type"
                              item-text="name"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md6 v-if="selectedType1 != null" style="padding-right:5px">
            <v-text-field disabled v-model="selectedType1.classNo" label="Total no of classes"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md6 v-if="selectedType1 != null">
            <v-text-field disabled v-model="selectedType1.classNo1" label="Remain classes"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-dialog ref="dialog" v-model="dateModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formA.date"
                                label="Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="formA.date" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="formA.remarks" label="Remarks"></v-text-field>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <h6 v-if="selectedType1 != null && selectedType1.classNo1 == 0" class="red--text">Your Class has been completed</h6>
            <v-btn v-if="selectedType1 != null && selectedType1.classNo1 > 0" depressed :loading="btnSave" color="primary" dark @click="onSubmitA()">Save </v-btn>
            <v-btn depressed color="orange" dark @click.stop="dialogA=false">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      </v-container>
      </v-card>
      
    </v-dialog>



    <v-dialog v-model="dialogM" width="700px">
      
      <v-card>
        <v-container>
         <v-form ref="formM" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-autocomplete
                              dense
                              v-model="selectedType1"
                              :items="type1"
                              label="Select Training Type"
                              item-text="name"
                              item-value="id"
                              ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="formM.classNo" label="Class No."></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-dialog ref="dialog" v-model="dateModel1" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formM.date"
                                label="Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="formM.date" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel1 = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="formM.result" label="Result"></v-text-field>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <v-btn v-if="selectedType1 != null" depressed :loading="btnSave" color="primary" dark @click="onSubmitM()">Save </v-btn>
            <v-btn depressed color="orange" dark @click.stop="dialogM=false">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      </v-container>
      </v-card>
      
    </v-dialog>


    <v-dialog v-model="dialogR" width="700px">
      
      <v-card>
        <v-container>
         <v-form ref="formR" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-autocomplete
                              dense
                              v-model="selectedType1"
                              :items="type1"
                              label="Select Training Type"
                              item-text="name"
                              item-value="id"
                              ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-dialog ref="dialog" v-model="rModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formR.registrationDate"
                                label="Registration Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="formR.registrationDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="rModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-dialog ref="dialog" v-model="tModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formR.testDate"
                                label="Test Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="formR.testDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="tModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
                              dense
                              v-model="selectedConformation"
                              :items="conformations"
                              label="Test Conformation"
                              item-text="conformations"
                              item-value="conformations"
                              ></v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-dialog ref="dialog" v-model="reModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="formR.resultDate"
                                label="Result Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="formR.resultDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="reModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="formR.result" label="Result"></v-text-field>
          </v-flex>

          <v-flex xs12 style="text-align:right">
            <v-btn v-if="selectedType1 != null" depressed :loading="btnSave" color="primary" dark @click="onSubmitR()">Save </v-btn>
            <v-btn depressed color="orange" dark @click.stop="dialogM=false">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      </v-container>
      </v-card>
      
    </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      tab: null,
      title: "Create Training",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      dateModel: false,
      dialog: false,
      dialogA: false,
      dialogM: false,
      dialogR: false,
      dialog1: false,
      edit: false,
      dateModel: false,
      dateModel1: false,

      rModel: false,
      tModel: false,
      reModel: false,

      conformations: ["Yes", "No"],
      selectedConformation: null,

      selected: 'details',
        options: [
          { text: 'Training Details', value: 'details' },
          { text: 'Attendance', value: 'attendance' },
          { text: 'Mock Test', value: 'mockTest' },
          { text: 'Test Registration', value: 'registration' }
        ],

      headers: [
        { text: "#", value: "#" },
        { text: "Training Type", value: "name" },
        { text: "Fee", value: "fee" },
        { text: "No. of Class", value: "classNo" },
        { text: "Mode", value: "mode" },
        { text: "Teacher", value: "fullName" },
        { text: "Remove", value: "remove" }
      ],

      header1: [
        { text: "#", value: "#" },
        { text: "Training Type", value: "name" },
        { text: "Reg Date", value: "registrationDate" },
        { text: "Conformation", value: "conformation" },
        { text: "Test Date", value: "testDate" },
        { text: "Result Date", value: "resultDate" },
        { text: "Result", value: "result" },
        { text: "Action", value: "action" }
      ],


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required."
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Training",
          disabled: false,
          to: "/training"
        },
        {
          text: "Edit",
          disabled: true,
          to: "/editTraining"
        }
      ],
      roleTypes: null,
      selectedRoleType: null,

      lead: null,
      selectedLead: null,

      type: null,
      selectedType: null,

      type1: null,
      selectedType1: null,

      typeM: null,
      selectedTypeM: null,

      teacher: null,
      selectedTeacher: null,

      mode: ["Online", "Offline"],
      selectedMode: "Offline",

      itemAdded: [],

      list: [],

      testList: [],

      registrations: [],

      form1: {
          fee: null,
          classNo: null
      },

      formA: {
        date: new Date().toISOString().substr(0, 10),
        remarks: null
      },

      formM: {
        date: new Date().toISOString().substr(0, 10),
        result: null,
        classNo: null
      },

      formR: {
        registrationDate: new Date().toISOString().substr(0, 10),
        result: null,
        resultDate: null,
        testDate: null
      },

      form: {
      }
    };
  },

  mounted() {
      this.axios
        .get(config.API + "Teachers", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.teacher = res.data;
          this.$Progress.finish();
        });

        this.getLead();
        this.getType();
        this.getData();
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    doMockTest() {
      this.dialogM = true;
    },

    doAttendance() {
      this.dialogA = true;
    },

    doRegistration() {
      this.dialogR = true;
    },

    leadBtn() {
        this.$router.push(`/createLead`);
    },

    viewDoc() {
        this.$router.push(`/imageUpload/` + this.form.leadId);
    },

    editItem1(item) {
        this.$router.push(`/registrationEdit/` + item.id);
    },

    getLead() {
        this.axios
        .get(config.API + "LeadSelection", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.lead = res.data;
          this.$Progress.finish();
          this.getLead();
        });
    },

    getType() {
        this.axios
        .get(config.API + "TrainingTypes", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.type = res.data;
          this.$Progress.finish();
          this.getType();
        });
    },

    getData() {
      this.axios
      .get(config.API + `Trainings/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.itemAdded = res.data.leadDetails;

        this.axios
        .get(config.API + "TypeSelection/" + this.form.leadId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.type1 = res.data;
          this.$Progress.finish();
        });

        this.axios
        .get(config.API + "Attendances/" + this.form.leadId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list = res.data;
          this.$Progress.finish();
        });

        this.axios
        .get(config.API + "MockTests1/" + this.form.leadId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.testList = res.data;
          this.$Progress.finish();
        });

        this.axios
        .get(config.API + "TestRegistrations1/" + this.form.leadId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.registrations = res.data;
          this.$Progress.finish();
        });
      });
    },

    close() {
      this.dialog1 = false;
      this.$refs.form1.reset();
    },
    editItem(item) {
      this.$router.push(`/editDetails/${item.ids}`);
    },

    deleteItem(item) {
      if(confirm("Are you sure you want to delete this selection?")) {
          this.axios
          .delete(config.API + `TrainingDetails/${item.ids}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            const index = this.itemAdded.indexOf(item);
            this.itemAdded.splice(index, 1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    deleteItem1(item) {
      if(confirm("Are you sure you want to delete this Registration?")) {
          this.axios
          .delete(config.API + `TestRegistrations/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Successfully deleted");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    save() {
        /* if (this.$refs.form1.validate()) { */
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
               typeId: JSON.parse(this.selectedType.id),
               name: this.selectedType.name,
               fee: JSON.parse(this.form1.fee),
               classNo: JSON.parse(this.form1.classNo),
               mode: this.selectedMode,
               teacherId: this.selectedTeacher.id,
               fullName: this.selectedTeacher.fullName
              });

              this.close();
            }
            else {
                let flag = false;

                for(let i = 0; i < lth; i++) {
                    let _typeId = this.itemAdded[i].typeId;

                    if(_typeId == this.selectedType.id) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Taken!!`);
               }
               else {
                   this.itemAdded.push({
               typeId: JSON.parse(this.selectedType.id),
               name: this.selectedType.name,
               fee: JSON.parse(this.form1.fee),
               classNo: JSON.parse(this.form1.classNo),
               mode: this.selectedMode,
               teacherId: this.selectedTeacher.id,
               fullName: this.selectedTeacher.fullName
              });

              this.close();
               }
            }
        //}
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Trainings/${this.$route.params.id}`,
            {
              id: JSON.parse(this.$route.params.id),
              admissionDate: this.form.admissionDate,

              trainingDetails: this.itemAdded
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Training successfully updated");
            this.$router.go(-1);
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmitA() {
      if (this.$refs.formA.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Attendances`,
            {
              leadId: JSON.parse(this.form.leadId),
              typeId: JSON.parse(this.selectedType1.id),
              date: this.formA.date,
              remarks: this.formA.remarks
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Attendance successfully added");
            this.dialogA = false;
            this.formA.remarks = null;
            this.selectedType1 = null;
            this.btnSave = false;
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },


    onSubmitM() {
      if (this.$refs.formM.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `MockTests`,
            {
              leadId: JSON.parse(this.form.leadId),
              trainingTypeId: JSON.parse(this.selectedType1),
              date: new Date(this.formM.date),
              result: this.formM.result,
              classNo: this.formM.classNo
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Mock Test successfully added");
            this.dialogM = false;
            this.formM.classNo = null;
            this.formM.result = null;
            this.selectedType1 = null;
            this.btnSave = false;
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmitR() {
      if (this.$refs.formR.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `TestRegistrations`,
            {
              leadId: JSON.parse(this.form.leadId),
              typeId: JSON.parse(this.selectedType1),
              registrationDate: new Date(this.formR.registrationDate),
              testDate: new Date(this.formR.testDate),
              resultDate: new Date(this.formR.resultDate),
              conformation: this.selectedConformation,
              result: this.formR.result
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Test Registration successfully added");
            this.dialogR = false;
            this.formR.result = null;
            this.formR.testDate = null;
            this.formR.resultDate = null;
            this.formR.registrationDate = new Date().toISOString().substr(0, 10);
            this.selectedConformation = null;
            this.selectedType1 = null;
            this.btnSave = false;
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  },

  computed: {
    mockData: function() {
      return this.testList.filter(srch => {
        return (
          srch.details.length > 0
        );
      });
    },
  }
};
</script>

<style>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: red !important;
  padding: 12px 15px;
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
</style>
